<ng-template [ngIf]="displayMode === 'default'">
  <div *ngIf="item && show" class="content-card vocabulary-card" [class.show]="show" [class.inline]="inline" [class.active]="active">
    <div *ngIf="canClose" class="close-btn" (click)="closeCard()">
      <app-icon class="close-btn-icon" icon="close"></app-icon>
    </div>

    <app-content-meta [meta]="meta"></app-content-meta>

    <div class="header">
      <ng-container *ngTemplateOutlet="authorTemplate"></ng-container>

      <div class="toolbar" *ngIf="isBrowser">
        <div class="copied-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | customLocale}}</span></div>
        <app-subscribe [user_id]="authorId"></app-subscribe>
        <app-bookmark [item]="item" type="content" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
        <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
      </div>
    </div>

    <div class="meta">
      <ng-container *ngTemplateOutlet="imgWrap"></ng-container>

      <div class="details">
        <div>
          <ng-container *ngTemplateOutlet="metaLinks"></ng-container>
        </div>

        <div *ngIf="terms.length && (me$ | async) && isAccessGranted" class="buttons">
          <on-ui-button *ngIf="selectedTermsCount"
                        [state]="state.playButton"
                        class="secondary"
                        [label]="('Учить слова' + ' (' + selectedTermsCount + ')')"
                        (onclick)="showPlaymode()">
          </on-ui-button>

          <on-ui-button class="secondary"
                        [label]="'Выбрать'"
                        (onclick)="showOptions()">
          </on-ui-button>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="termsTemplate"></ng-container>

    <ng-container *ngTemplateOutlet="buttonsMini"></ng-container>

    <ng-template [ngIf]="item">
      <app-share-and-stats
        [content_id]="item.id"
        [stats]="item.stats"
        [visit_info]="item.visit_info"
        (shared)="onCopied($event)"
        (changed)="onShareAndStatsChange($event)"></app-share-and-stats>

      <app-content-comments
        [content]="item"
        (commented)="setIsCommented()"
        (changed)="onCommentsChange($event)"></app-content-comments>
    </ng-template>

    <app-lesson-game
      *ngIf="state.play"
      [gameMode]="state.gameMode"
      [lessonId]="item?.id"
      [author]="author"
      (closed)="stopPlay()"></app-lesson-game>
  </div>
</ng-template>

<ng-template [ngIf]="displayMode === 'content_page'">
  <div class="content-card-content-page">
    <app-content-meta [meta]="meta"></app-content-meta>

    <div class="meta">
      <ng-container *ngTemplateOutlet="imgWrap"></ng-container>
      <ng-container *ngTemplateOutlet="metaLinks"></ng-container>
    </div>

    <ng-container *ngTemplateOutlet="termsTemplate"></ng-container>

    <ng-container *ngTemplateOutlet="buttonsMini"></ng-container>

    <app-share-and-stats [content_id]="item?.id"
                         [stats]="item?.stats"
                         [visit_info]="item?.visit_info"
                         [displayMode]="'content_page'"
                         (shared)="onCopied($event)"
                         (changed)="onShareAndStatsChange($event)">
      <div bookmark>
        <app-bookmark [item]="item" type="content"></app-bookmark>
      </div>
      <div menu>
        <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
      </div>
    </app-share-and-stats>

    <div class="author-block">
      <ng-container *ngTemplateOutlet="authorTemplate"></ng-container>
      <app-subscribe [user_id]="authorId"></app-subscribe>
    </div>

    <app-content-comments [content]="item"
                          (commented)="setIsCommented()"
                          (changed)="onCommentsChange($event)">
    </app-content-comments>
  </div>
</ng-template>

<ng-template #metaLinks>
  <div class="meta-links">
    <h1 class="title bold"><a [routerLink]="contentRoute(item)">{{ title }}</a></h1>
    <h2 class="subject-wrap">
      <a *ngIf="subjectRoute" [routerLink]="subjectRoute" class="subject bold">{{ subject }}</a>
      <span *ngIf="!subjectRoute" class="subject bold">{{ subject }}</span>

      <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
        <span class="subject-category normal">{{ 'content-mini-card.native' | customLocale }}</span>
      </ng-template>
    </h2>

    <h3 class="subtitle normal" *ngIf="item.sub_title"><a [routerLink]="contentRoute(item)">{{ sub_title }}</a></h3>
    <h4 class="type-and-level normal">
      <a *ngIf="contentTypeRoute" [routerLink]="contentTypeRoute"
         [attr.title]="(contentTypeTitle | customLocale) + ', ' + (level)">
        {{ contentTypeTitle | customLocale }}, {{ level }}
      </a>
      <span *ngIf="!contentTypeRoute">{{ contentTypeTitle | customLocale }}, {{ level }}</span>
      <br/>
      <span>{{ 'constructor2.form-language-label' | customLocale }}: {{ teachingLanguage }}</span>
    </h4>
  </div>
</ng-template>

<ng-template #authorTemplate>
  <div class="author">
    <div class="author-avatar-wrap">
      <on-ui-cover [cover]="authorImg" [attr.data-test] = "'authorPhoto'"></on-ui-cover>
    </div>
    <div class="info">
      <a [routerLink]="accountRoute(author)" *ngIf="author" class="author-name">
        <span itemprop="author">{{ authorFullName }}</span>
      </a>
      <div class="stats-wrap">
        <app-rating [stats]="stats"></app-rating>
        <span class="published-date" *ngIf="isAuthUser">{{ contentDate | dfnsFormatDistanceToNowStrictPure: {addSuffix: true} }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #imgWrap>
  <div class="img-wrap">
    <on-ui-cover [cover]="cover" [attr.data-test] = "'coverImg'"></on-ui-cover>
  </div>
</ng-template>

<ng-template #termsTemplate>
  <p class="terms" *ngIf="terms.length">
    <span class="terms-title">В этом уроке:</span>
    <span><span class="terms-term" *ngFor="let term of terms; trackBy: trackByFn" [innerHTML]="term.term | striptags"></span></span>
    <span class="terms-cut" *ngIf="isCutable && isAccessGranted" (click)="toggleCut()">{{ (state.cut ? 'показать все' : 'скрыть') | customLocale }}</span>
  </p>
</ng-template>

<ng-template #menuTemplate>
  <on-ui-card-menu [item]="item">
    <a class="menu-item"
       *ngIf="isAuthor"
       [routerLink]="['/constructor/edit', item.id]">
      {{ 'library.menu-edit' | customLocale }}</a>
    <a class="menu-item warn"
       *ngIf="!isAuthor && isModerator"
       [routerLink]="['/constructor/edit', item.id]">[⚠️] Edit</a>
    <a class="menu-item warn"
       *ngIf="item.purl" [href]="item.purl">[⚠️] Panel</a>
    <div class="menu-item"
         *ngIf="state.subscribed"
         (click)="unsubscribe()">{{ 'library.menu-unsubscribe' | customLocale }}</div>
    <div *ngIf="isAvailableStatistics" class="menu-item" #shareLinkRef>
      <button type="button"
              [ngxClipboard]
              [cbContent]="contentUrl"
              (cbOnSuccess)="onCopied($event)"
              [container]="shareLinkRef">{{ 'library.menu-share' | customLocale }}<!-- Поделиться -->
      </button>
    </div>
    <div class="menu-item"
         *ngIf="!isAuthor && isAccessGranted"
         (click)="openComplainForm()">{{ 'library.menu-complain' | customLocale }}<!-- Пожаловаться --></div>
  </on-ui-card-menu>
</ng-template>

<ng-template #buttonsMini>
  <div *ngIf="terms.length && (me$ | async) && isAccessGranted" class="buttons-mini">
    <on-ui-button *ngIf="selectedTermsCount"
                  [state]="state.playButton"
                  class="secondary"
                  [label]="('Учить слова' + ' (' + selectedTermsCount + ')')"
                  (onclick)="showPlaymode()"></on-ui-button>
    <on-ui-button class="secondary"
                  [label]="'Выбрать'"
                  (onclick)="showOptions()">
    </on-ui-button>
  </div>
</ng-template>

<app-modal *ngIf="state.complainFormOpened && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()"></app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="state.complainFormOpened && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()"></app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>


<app-modal id="vocabulary-options" *ngIf="state.optionsOpen" (closed)="hideOptions()">
  <app-modal-body>
    <app-vocabulary-options
      [vocabulary]="item"
      (selected)="onOptionsSelected($event)"></app-vocabulary-options>
  </app-modal-body>
</app-modal>

<app-modal id="vocabulary-play" *ngIf="state.playmodeOpen" (closed)="hidePlaymode()">
  <app-modal-body>
    <app-vocabulary-playmode
      [vocabulary]="item"
      (options)="hidePlaymode(); showOptions();"
      (playmode)="prepareGame($event)"></app-vocabulary-playmode>
  </app-modal-body>
</app-modal>
